import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { withTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Payment from "../components/Payment";
import ShipmentDetailsCard from "../components/Shipmentdetailscard";
import Documents from "../components/Document";
import CargoDetails from "../components/CargoDetails";
import { basename } from "../../../Config";
import instance from "../../../api/interceptor";
import { API_PATH } from "../../../constant/apiPath";
import { routeConstant } from "../../../routing";
import LocateOnMap from "../components/LocateOnMap";
import Milestone from "../components/Milestone";
import RecivableDocuments from "../components/RecivableDocuments";
import Nodata from "../../../components/Nodata";
import urlResolver from "../../../utils/urlResolver";
import { LOCAL_STORAGE_USER_KEY } from "../../../Config";
import { useSelector } from "react-redux";
function ProcessDetails(props) {
  const location = useLocation();
  const [detailsdata, setDetailsdata] = useState({});
  const [cargodetailsdata, setCargodetailsdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shipmentDetailsLoading, setShipmentDetailsLoading] = useState(true);
  const [paymentdocs, setPaymentdocs] = useState([]);
  const [boldocs, setBoldocs] = useState([]);
  const navigate = useNavigate();
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const controller = new AbortController();
  const signal = controller.signal;
  const [checkAbort, setCheckAbort] = useState(false);
  const [statusCheck, setStatusCheck] = useState(false);
  const [transportData, setTransportData] = useState({});
  const [terminalData, setTerminalData] = useState({});
  const [cabotagemData, setCabotagemData] = useState({});
  const { t } = props;
  useEffect(() => {
    const item = location?.state?.item || {};
    console.log('item', item);
    
    const { type, ShipmentID: shipmentId, status } = item;

    // status flag is used to show the "no data" screen
    setStatusCheck(status === false);

    if (shipmentId) {
      getShipmentDetails(shipmentId);
      console.log('inside shipment id block');

      // fetch additional details based on the row type
      if (type === "Terminal") {
        getTerminalDetails(shipmentId);
      } else if ("Transport" in item) {
        getTransportDetails(shipmentId);
      } else if (type === "Cabotage") {
        console.log('inside get Cabotagem Details id block');
        getCabotagemDetails(shipmentId);
      }

      // cargo documents are needed for every non‑shipment row
      getCargoDocument(shipmentId);
    }

    return () => {
      setCheckAbort(true);
      setDetailsdata({});
      controller.abort();
    };
  }, [location?.state?.item]);

  const getShipmentDetails = (i) => {
    setLoading(true);
    setShipmentDetailsLoading(true);
    const payload = {
      ShipmentId: i,
    };
    if (i !== "")
      instance
        .post(API_PATH.GET_SHIPMENT_DETAILS, payload, { signal })
        .then((res) => {
          if (res._IsSuccess) {
            setDetailsdata(res?._Data ?? {});
            // getPaymentDocs();
          } else {
            setDetailsdata({});
            // getPaymentDocs();
          }
          setLoading(false);
          setShipmentDetailsLoading(false);
        })
        .catch((err) => {
          setDetailsdata({});

          console.log("get shipment details error", err);
          if (!checkAbort) setLoading(false);
          setShipmentDetailsLoading(false);
        });
  };

  const getCargoDocument = (i) => {
    setLoading(true);
    const url = `${API_PATH.GET_CARGO_DOCUMENT}?transportid=${i}`;
    instance
      .post(url)
      .then((res) => {
        if (res._IsSuccess) {
          setCargodetailsdata(res?._Data ?? []);
        } else {
          setCargodetailsdata([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setCargodetailsdata([]);
        setLoading(false);
        console.log("get shipment details error", err);
      });
  };

  const getTransportDetails = (i) => {
    setLoading(true);
    const url = `${API_PATH.GET_TRANSPORT_DETAILS}?transportid=${i}`;
    instance
      .get(url)
      .then((res) => {
        if (res._IsSuccess) {
          setTransportData(res?._Data ?? {});
        } else {
          setTransportData({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setTransportData({});
        setLoading(false);
        console.log("get shipment details error", err);
      });
  };
  
  const getCabotagemDetails = (i) => {
    setLoading(true);
    const url = `${API_PATH.GET_CABOTAGE_DETAILS}?shipmentid=${i}`;
    instance
      .get(url)
      .then((res) => {
        if (res._IsSuccess) {
          setCabotagemData(res?._Data ?? {});
        } else {
          setCabotagemData({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setCabotagemData({});
        setLoading(false);
        console.log("get cabotagem details error", err);
      });
  };

  const getTerminalDetails = (shipmentId) => {
    setLoading(true);
    const url = `${API_PATH.GET_TERMINAL_DETAILS}?ShipmentId=${shipmentId}`;

    instance
      .get(url)
      .then((res) => {
        if (res?._IsSuccess) {
          setTerminalData(res?._Data ?? {});
        } else {
          setTerminalData({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setTerminalData({});
        setLoading(false);
        console.log("get terminal details error", err);
      });
  };

  const onOrderClick = (item) => {
    const path = `${routeConstant.ORDER}/${routeConstant.ORDERDETAILS}`;
    navigate(path, {
      state: {
        item: item,
        from: "process",
      },
    });
  };

  if (statusCheck) {
    return <Nodata />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <>
          <div className="col-12 col-lg-8 ">
            <ShipmentDetailsCard
              t={t}
              detailsdata={detailsdata}
              shipmentType={location?.state?.item?.type}
              transportData={transportData}
              loading={
                Object.keys(detailsdata)?.length === 0 &&
                Object.keys(transportData)?.length === 0
                  ? true
                  : loading
              }
              shipmentDetailsLoading={shipmentDetailsLoading}
              terminalData={terminalData}
              cabotagemData={cabotagemData}
            />
            {location?.state?.item?.type === "Shipment" ||
            location?.state?.item?.type === "Terminal" ||
            location?.state?.item?.type === "Cabotage" ? (
              ""
            ) : (
              <Payment
                boldocs={boldocs}
                t={t}
                cargodetailsdata={cargodetailsdata}
                setCargodetailsdata={setCargodetailsdata}
              /> 
            )}

            <RecivableDocuments paymentdocs={paymentdocs} t={t} />
            {["Shipment", "Terminal", "Transport"].includes(
              location?.state?.item?.type,
            ) && (
              <Documents
                t={t}
                cargodetailsdata={cargodetailsdata}
                setCargodetailsdata={setCargodetailsdata}
              />
            )}
            <CargoDetails
              t={t}
              loading={loading}
              clientNotes={transportData?.transportContainerLegs ?? []}
            />
          </div>
          <div className="col-12 col-lg-4 pe-0 ">
            {loading ? (
              ""
            ) : (
              <div
                style={{
                  maxHeight: "30vh",
                  overflowY: "auto",
                  paddingRight: "0.5rem",
                }}
              >
                {detailsdata?.OrderCollection?.map((item, index) => {
                  return (
                    <div
                      className="map-head d-flex pointer"
                      key={index}
                      onClick={() => {
                        onOrderClick(item);
                      }}
                    >
                      <div className="d-flex   map-img ">
                        <img src={urlResolver("icon/icon-paper.svg")} />
                        <div className=" map-line m-2"></div>
                      </div>
                      <div className="map-top-div">
                        <p className="color-grey">{t("Order")}:</p>
                        <p className="color-blue2">{item?.OrderNumber ?? ""}</p>
                      </div>
                      <div className="map-card-div ">
                        <ArrowForwardIosIcon className="map-card-arrow" />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="map-main-comp">
              {location?.state?.item?.type === "Shipment" || location?.state?.item?.type === "Cabotage" ? (
                <div className="map-milestone-div">
                  <div className="map-milestone-div-child">
                    <LocateOnMap />
                  </div>
                  <Milestone />
                </div>
              ) : (
                <div className="map-milestone-div">
                  <Milestone />
                </div>
              )}
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default withTranslation()(ProcessDetails);
